<mat-icon *ngIf="showIcon" [style.color]="iconColor">
  drag_handle
</mat-icon>
